import React, { useContext, useEffect, useState } from "react"
import { Box, Text, Flex } from "@theme-ui/components"
import { motion } from "framer-motion"
import { FaWhatsapp } from "react-icons/fa"
import { i18nContext } from "../context/i18nContext"

const WhatsAppIcon = ({ phoneNumber = "+393783081681" }) => {
  const i18n = useContext(i18nContext)
  const [isVisible, setIsVisible] = useState(false)

  // Trigger animation on component mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 500) // Small delay before animation starts

    return () => clearTimeout(timer)
  }, [])

  const handleWhatsAppClick = () => {
    // Track the click event with GTM
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: 'clicked_whatsapp_icon',
        event_category: 'engagement',
        event_label: 'whatsapp_contact',
        phone_number: phoneNumber,
      })
    }

    // Track the click event with Simple Analytics
    if (typeof window !== 'undefined' && window.sa_event) {
      window.sa_event('clicked_whatsapp_icon')
    }

    const message = "Ciao, nuova richiesta di contatto Socaf."
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/[^\d]/g, '')}?text=${message}`

    // Open in new window/tab
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer')
  }

  // Business hours logic (currently 24/7)
  const isBusinessHours = () => {
    // For now, always return true (24/7)
    // Future implementation can check actual business hours
    return true
  }

  if (!isBusinessHours()) {
    return null
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 100 }}
      animate={isVisible ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
      transition={{
        duration: 0.8,
        type: "spring",
        stiffness: 100,
        damping: 15
      }}
    >
      <Flex
        sx={{
          mr: [2],
          alignItems: "center",
          gap: 0,
          cursor: "pointer",
          transformOrigin: "bottom",
          transition: "transform 0.3s ease",
          "&:hover": {
            transform: "scale(1.05)",
          }
        }}
        onClick={handleWhatsAppClick}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            handleWhatsAppClick()
          }
        }}
        aria-label={i18n.whatsappLabel}
      >
        {/* Text label - only visible on desktop */}
        <Text
          sx={{
            display: ["none", "block"], // Hidden on mobile/tablet, visible on desktop
            backgroundColor: "#25D366",
            color: "white",
            paddingLeft: 3,
            paddingRight: 6,
            mr: -5,
            py: [2],
            // borderRadius: "1000px",
            fontSize: [1, 2],
            fontWeight: "bold",
            whiteSpace: "nowrap",
            boxShadow: "0 4px 12px rgba(37, 211, 102, 0.3)"
          }}
        >
          WhatsApp
        </Text>

        {/* WhatsApp Icon */}
        <Box
          sx={{
            backgroundColor: "#25D366",
            // borderRadius: "50%",
            width: "40px",
            height: "40px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 4px 12px rgba(37, 211, 102, 0.4)",
            color: "white"
          }}
        >
          <FaWhatsapp size={28} />
        </Box>
      </Flex>
    </motion.div>
  )
}

export default WhatsAppIcon 